import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export async function doLogin(email, password, totp) {
    const loginUrl = `${API_URL}/login`;
    const response = await axios.post(loginUrl, { email, password, totp });
    return response.data;
}

export async function doLogout() {
    const logoutUrl = `${API_URL}/logout`;
    const response = await axios.post(logoutUrl, {});
    return response.data;
}

export async function requestPasswordReset(email) {
    const url = `${API_URL}/forgot-password`;
    const response = await axios.post(url, { email });
    return response.data;
}